import {jsonRequest} from "./common";
import * as CONFIG from '../config';

/**
 * @typedef {Object} CountryMeta
 * @property {Object} zip
 * @property {boolean} zip.show
 * @property {Object} state
 * @property {string} state.name
 * @property {boolean} state.show
 * @property {*} state.values
 */

/**
 * @typedef {Object} Country
 * @property {string} id
 * @property {string} text
 * @property {string} genitive
 * @property {string} link_name
 * @property {CountryMeta} [meta]
 * @property {boolean} eu
 * @property {boolean} send_from
 * @property {string} pattern
 */

const results = {};

/**
 *
 * @param {boolean} onlyEU
 * @param {boolean} onlySendFrom
 * @return {Promise<Array<Country>>}
 */
export function countries(onlyEU, onlySendFrom) {
    if (onlyEU) {
        return results.onlyEU || (results.onlyEU = fetch('_eu'));
    } else if (onlySendFrom) {
        return results.onlySendFrom || (results.onlySendFrom = fetch('_from'));
    }
    return results.all || (results.all = fetch(false));
}

function fetch(countriesOption) {
    let url = CONFIG.API_URL + '/get_available_countries';
    if(countriesOption){
        url += countriesOption;
    }
    return jsonRequest(url);
}